import common from '../common'

export default {
    budget(params) {
      return common.get('/rocheManage/dashboard/dashboardBudget/queryData',params);
    },

    meeting(params) {
      return common.get('/rocheManage/dashboard/dashboardMeeting/meetingDistribute',params);
    },

    effectiveness(params) {
      return common.get('/rocheManage/dashboard/dashboardScore/queryScoreData',params);
    },

    getTableauTicket(params) {
      return common.get('/rocheManage/sys/tableau/ticket',params);
    },

    // 停留时间保存 enterTime"进入时间" leaveTime "离开时间" description"模块名称"
    saveStayTime(params) {
      return common.post('/rocheManage/sys/log/saveStayTime',params);
    },

}



// WEBPACK FOOTER //
// ./src/api/dashboard/index.js